import { Button, Input, Popover, Segmented, Select, Typography } from "antd";
import "./ConnectionModel.css";
import { v4 as uuidv4 } from "uuid";
import DataBaseImage from "../../../../assets/icons/Database.svg";
import { ErrorMessage, Field, Form, Formik } from "formik";
import EyeIcon from "../../../../assets/icons/eyeOpened.svg";
import EyeSlashIcon from "../../../../assets/icons/eyeClosed.svg";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import search from "../../../../assets/icons/searchIconNew.svg";
import dropdownIcon from "../../../../assets/icons/dropdownIcon.svg";
import React from "react";
import { useDispatch } from "react-redux";
import { REGEX_PATTERNS } from "../../../../utilities/common";
import { credentialDecryption, credentialEncryption } from "../../../../utilities/utils";
import useDebounce from "../../../../hooks/useDebounce";
import { showErrorToast, showSuccessToast } from "../../../../utilities/toastUtils";
import { useConnectionDeleteMutation, useConnectionListQuery, useGetConnectionDataQuery, useSemanticCreateConnectionMutation } from "../../../../service/apiSlices/sematicModel";
import { databaselist, ROUTES, TOKENS } from "../../../../utilities/Constants/Constants";
import DeleteConfirmModel from "../../../DeleteConfirModel/DeleteConfirmModel";
import TopnavBar from "./TopnavBar";
interface ConnectionModalProps {
    connectionType: string;
}

const ConnectionModal = ({ connectionType }: ConnectionModalProps) => {
    const [view, setView] = useState(false);
    const dispatch = useDispatch();
    const [params, setParams] = useState([{ key: "", value: "" }]);
    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const [queryId, setQueryId] = useState<any>("");
    type Align = "All" | "Last Created" | "Recently opened";
    const [alignValue, setAlignValue] = React.useState<Align>("All");
    const [openPopoverIndex, setOpenPopoverIndex] = useState<number | null>(null);
    const [listToRender, setListToRender] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const formikRef = useRef<any>(null);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const navigate = useNavigate();
    const { t } = useTranslation("common");
    const [selectedConnectionId, setSelectedConnectionId] = useState<string>("");

    const defaultInitialValues = {
        userName: "",
        connectionname: "",
        host: "",
        port: "",
        database: "",
        dataBasetype: "mysql",
        password: "",
        pemFile: "",
        params: params,
    };
    const [initialValues, setInitialValues] = useState(defaultInitialValues);

    const debouncedSearchText = useDebounce(searchValue);
    const [semanticConnection] = useSemanticCreateConnectionMutation();
    const [check, setcheck] = useState(false);
    const [selectedModuleIds, setSelectedModuleIds] = useState<string[]>([]);
    const [isActive, setIsActive] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState<{ state: boolean; Databasename: string[] }>({
        state: false,
        Databasename: [],
    });

    const payload = {
        search: debouncedSearchText,
        page: 1,
        perpage: 10,
    };

    const { data: connectionList, refetch: refetchDbSemanticModel, isLoading: connectionListLoading } = useConnectionListQuery(payload);


    const [sementicConnectionDelete] = useConnectionDeleteMutation();

    useEffect(() => {
        // Replace current history with DBConnection page so user can't go back
        navigate(ROUTES.DASHBOARD, { replace: true });
        window.history.pushState(null, '', window.location.href);

        const handlePopState = () => {
            window.history.pushState(null, '', window.location.href);
        };

        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [navigate]);
    useEffect(() => {
        setListToRender(connectionList?.data);

    }, [connectionList]);

    useEffect(() => {

        setInitialValues(defaultInitialValues);
        setDeleteModalOpen({ state: false, Databasename: [] });
        setcheck(false)
        setSelectedConnectionId("");
        setSelectedModuleIds([])

        // Reset the form if formikRef is available
        if (formikRef.current) {
            formikRef.current.resetForm();
        }

        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    }, [connectionType]);

    const shouldFetchData =
        connectionType !== "db_dashboad" && !!selectedConnectionId;


    const { data: connectionData, refetch: refetchData } =
        useGetConnectionDataQuery(selectedConnectionId, { skip: !shouldFetchData });

    useEffect(() => {
        setIsActive(false);
    }, [connectionType])

    const connectedList: any =
        connectionData?.data;

    useEffect(() => {
        if (!selectedConnectionId) return;

        refetchData();

    }, [connectionType, selectedConnectionId]);

    useEffect(() => {
        if (connectedList) {
            setInitialValues((prevValues) => ({
                ...prevValues,
                userName: connectedList.user_name ? credentialDecryption(connectedList.user_name) : "",
                host: connectedList.host ? credentialDecryption(connectedList.host) : "",
                port: connectedList.port ? credentialDecryption(connectedList.port) : "",
                connectionname: connectedList?.session_key || connectedList?.connection_name || "",
                database: connectedList.database_name ? credentialDecryption(connectedList.database_name) : "",
                dataBasetype: connectedList.database_type || "mysql",
            }));
            setSelectedConnectionId("");
        }
    }, [connectedList]);

    const validationSchema = Yup.object({
        userName: Yup.string().required("User name is required"),
        connectionname: Yup.string().required("Connection name is required"),
        password: Yup.string().required("Password is required"),
        host: Yup.string().required("host is required").matches(REGEX_PATTERNS?.numberWithDotshostRegex, "Invalid host format"),
        port: Yup.string().required("Port is required").matches(REGEX_PATTERNS?.onlyNumberportRegex, "Invalid port format"),
        database: Yup.string().required("database name is required"),
        dataBasetype: Yup.string().required("dataBasetype is required"),
    });

    const handlePassword = (e: any) => {
        e.preventDefault();
        const input: any = document.querySelector('input[name="password"]');
        const cursorPosition = input.selectionStart;
        setView((view) => !view);
        setTimeout(() => {
            input.focus();
            input.setSelectionRange(cursorPosition, cursorPosition);
        }, 0);
    };
    const onSubmit = (values: typeof initialValues) => {

        let normalizedHost = values.host
            .trim()
            .replace(/^https?:\/\//i, "")
            .replace(/\/+$/, "");

        let payload: any = {
            database_type: values.dataBasetype,
            database_name: credentialEncryption(values.database),
            connection_name: values.connectionname,
            host: credentialEncryption(normalizedHost),
            port: credentialEncryption(values.port.toString()),
            user_name: credentialEncryption(values.userName),
            password: credentialEncryption(values.password),
        };

        semanticConnection(payload)
            .unwrap()
            .then((response: any) => {
                if (response.status_code == 200) {
                    sessionStorage.setItem(
                        TOKENS.CONNECTION_ID,
                        response?.connection_key
                    );
                    showSuccessToast(response.message);
                    if (!response?.is_query_available) {
                        navigate(ROUTES.SEMANTIC_MODEL);
                    } else {
                        navigate(ROUTES.QUERYLIST);
                    }
                } else {
                    showErrorToast(response.message);
                }
            })
            .catch((err: any) => {
                showErrorToast(err?.data?.message);
            });

    };

    useEffect(() => {
        sessionStorage.removeItem(TOKENS.CONNECTION_ID);

        window.history.replaceState(null, "", window.location.href);
    }, []);

    const connection_Id: any = sessionStorage.getItem(TOKENS.CONNECTION_ID);

    const cardActions = (index: any, item: any) => {
        return (
            <div className="d-flex flex-column justify-content-center">
                <div
                    className="d-flex gap-2 delete-btn border-0"
                    onClick={() => {
                        setDeleteModal(true);
                        setQueryId(item?._id);
                        setOpenPopoverIndex(null);
                    }}
                >
                    {/* <img src={DeleteIcon} alt="Delete" className="ms-1" /> {t('Delete')} */}
                </div>
            </div>
        );
    };

    const handleAddParams = (setFieldValue: any, values: any) => {
        const newParams = [...values.params, { key: "", value: "" }];
        setParams(newParams);
        setFieldValue("params", newParams);
    };

    const handleRemoveParam = (
        indexToRemove: any,
        setFieldValue: any,
        values: any
    ) => {
        if (values.params.length > 1) {
            const newParams = [...values.params];
            newParams.splice(indexToRemove, 1);
            setFieldValue("params", newParams);

            // Also update the component state to keep in sync
            setParams(newParams);
        }
    };
    const handleGetDatabaseDetails = (res: any) => {
        setSelectedConnectionId(res?.connection_key);
    };

    const handleFileChange = (
        event: React.ChangeEvent<HTMLInputElement>,
        setFieldValue: Function
    ) => {
        const file = event.currentTarget.files?.[0];
        if (file) {
            setFieldValue("pemFile", file);
            setFieldValue("pemFileName", file.name);
        }
    };
    const handlecheck = () => {
        setcheck((pre: any) => (!pre))
        setSelectedModuleIds([])
        setDeleteModalOpen({
            state: false,
            Databasename: [],
        })
    }
    const handleCOnfirmDelete = () => {
        if (selectedModuleIds?.length > 0) {
            setDeleteModalOpen((preve) => ({ state: true, Databasename: preve.Databasename }))
        }
    }
    const onModelChecked = (data: any) => {
        const { connection_key, connectionId, database_name } = data;
        const key = connection_key || connectionId;

        if (selectedModuleIds.includes(key)) {
            setSelectedModuleIds((prev) => prev.filter((id) => id !== key));
            setDeleteModalOpen((prevState) => ({
                ...prevState,
                Databasename: prevState.Databasename.filter((id) => id !== key),
            }));
        } else {
            setSelectedModuleIds((prev) => [...prev, key]);
            setDeleteModalOpen((prevState) => ({
                ...prevState,
                Databasename: [...prevState.Databasename, key],
            }));
        }
    }
    const resetState = () => {
        setIsActive(false);
        setcheck(false)
        setSelectedModuleIds([])
        setDeleteModalOpen({ state: false, Databasename: [] });
    }

    const preventAction = (e: React.ClipboardEvent<HTMLInputElement>) => {
        e.preventDefault();
    };

    const handleDeleteDatabase = () => {
        if (!selectedModuleIds) return;
        const payload = {
            connection_key: selectedModuleIds
        }
        sementicConnectionDelete(payload).
            unwrap().then((res: any) => {
                if (res?.data) {
                    refetchDbSemanticModel();
                    showSuccessToast(res?.message)
                }
                resetState();
            }).catch((err: any) => {
                console.error("API Error:", err);
            })

    }
    return (
        <div className="row justify-content-center align-items-center w-100">
            <div className="col-md-10">
                <div className="copilot-model copilot-connection-container">
                    <div className="sub-connection">
                        <div>
                            <Formik
                                initialValues={initialValues}
                                validationSchema={validationSchema}
                                onSubmit={onSubmit}
                                enableReinitialize
                                innerRef={formikRef}
                            >
                                {({
                                    isSubmitting,
                                    setFieldValue,
                                    values,
                                    handleChange,
                                    handleSubmit,
                                    errors,
                                    touched,
                                    resetForm,
                                }) => (
                                    <Form>
                                        <div className="row justify-content-md-center">
                                            <div className="col-md-5 col-lg-4 d-flex">
                                                <div className="connect-db w-100">
                                                    <div className="copilot-title-txt">
                                                        Connection Name
                                                    </div>
                                                    <div className="form-fields-wrapper">
                                                        <div className="input-wrapper-connection">
                                                            <div className="copilot-label-txt">
                                                                {t("Databasetype")}
                                                            </div>
                                                            <Field
                                                                name="dataBasetype"
                                                                as={Select}
                                                                className="copilot-select"
                                                                suffixIcon={
                                                                    <img src={dropdownIcon} alt="dropdown" />
                                                                }
                                                                onChange={(value: any) =>
                                                                    setFieldValue("dataBasetype", value)
                                                                }
                                                                value={values.dataBasetype}
                                                                options={databaselist.map(
                                                                    (item: any, idx: number) => ({
                                                                        value: item.value,
                                                                        label: item.label,
                                                                    })
                                                                )}
                                                            />
                                                            <ErrorMessage
                                                                name="dataBasetype"
                                                                component="div"
                                                                className="text-danger"
                                                            />
                                                        </div>
                                                        <div className="input-wrapper-connection">
                                                            <label className="copilot-label-txt ">
                                                                {t("Connection Name")}
                                                            </label>
                                                            <Field
                                                                name="connectionname"
                                                                as={Input}
                                                                onChange={handleChange}
                                                                placeholder="Connection Name"
                                                                className="copilot-model-input"
                                                                onCopy={preventAction}
                                                                onPaste={preventAction}
                                                                onCut={preventAction}
                                                                status={
                                                                    touched.userName && errors.connectionname
                                                                        ? "error"
                                                                        : ""
                                                                }
                                                                disabled={(connectedList?.session_key || connectedList?.connection_name) ? true : false}
                                                                value={values.connectionname}
                                                            />
                                                            <ErrorMessage
                                                                name="connectionname"
                                                                component="div"
                                                                className="text-danger"
                                                            />
                                                        </div>
                                                        <div className="input-wrapper-connection">
                                                            <label className="copilot-label-txt ">
                                                                {t("UserName")}
                                                            </label>
                                                            <Field
                                                                name="userName"
                                                                as={Input}
                                                                onChange={handleChange}
                                                                placeholder="Database username"
                                                                className="copilot-model-input"
                                                                onCopy={preventAction}
                                                                onPaste={preventAction}
                                                                onCut={preventAction}
                                                                status={
                                                                    touched.userName && errors.userName
                                                                        ? "error"
                                                                        : ""
                                                                }
                                                                disabled={(connectedList?.user_name) ? true : false}
                                                                value={values.userName}
                                                            />
                                                            <ErrorMessage
                                                                name="userName"
                                                                component="div"
                                                                className="text-danger"
                                                            />
                                                        </div>
                                                        <div className="input-wrapper-connection">
                                                            <label className="copilot-label-txt">
                                                                {t("Password")}
                                                            </label>
                                                            <Field
                                                                name="password"
                                                                as={Input}
                                                                type={view ? "text" : "password"}
                                                                placeholder="Database password"
                                                                className="copilot-model-input"
                                                                onCopy={preventAction}
                                                                onPaste={preventAction}
                                                                onCut={preventAction}
                                                                suffix={
                                                                    <img
                                                                        src={view ? EyeIcon : EyeSlashIcon}
                                                                        alt="eye"
                                                                        onClick={(e: any) => handlePassword(e)}
                                                                    />
                                                                }
                                                                status={
                                                                    touched.password && errors.password
                                                                        ? "error"
                                                                        : ""
                                                                }
                                                                value={values.password}
                                                            />
                                                            <ErrorMessage
                                                                name="password"
                                                                component="div"
                                                                className="text-danger"
                                                            />
                                                        </div>
                                                        <div className="row g-2 w-100 ">
                                                            <div className="col-md-12 col-lg-6">
                                                                <label className="copilot-label-txt ">
                                                                    {t("Host")}
                                                                </label>
                                                                <Field
                                                                    name="host"
                                                                    as={Input}
                                                                    onChange={handleChange}
                                                                    className="copilot-model-input"
                                                                    placeholder="Eg.192.168.1.1"
                                                                    onCopy={preventAction}
                                                                    onPaste={preventAction}
                                                                    onCut={preventAction}
                                                                    status={
                                                                        touched.host && errors.host ? "error" : ""
                                                                    }
                                                                    value={values.host}
                                                                />
                                                                <ErrorMessage
                                                                    name="host"
                                                                    component="div"
                                                                    className="text-danger"
                                                                />
                                                            </div>
                                                            <div className="col-md-12 col-lg-4">
                                                                <label className="copilot-label-txt">
                                                                    {t("Port")}
                                                                </label>
                                                                <Field
                                                                    name="port"
                                                                    as={Input}
                                                                    onChange={handleChange}
                                                                    className="copilot-model-input"
                                                                    placeholder="Eg.3306"
                                                                    onCopy={preventAction}
                                                                    onPaste={preventAction}
                                                                    onCut={preventAction}
                                                                    status={
                                                                        touched.port && errors.port ? "error" : ""
                                                                    }
                                                                    disabled={(connectedList?.port) ? true : false}
                                                                    value={values.port}
                                                                />
                                                                <ErrorMessage
                                                                    name="port"
                                                                    component="div"
                                                                    className="text-danger"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="input-wrapper-connection">
                                                            <label className="copilot-label-txt">
                                                                {t("DatabaseName")}
                                                            </label>
                                                            <Field
                                                                name="database"
                                                                as={Input}
                                                                onChange={handleChange}
                                                                className="copilot-model-input"
                                                                placeholder="Enter database name"
                                                                onCopy={preventAction}
                                                                onPaste={preventAction}
                                                                onCut={preventAction}
                                                                status={
                                                                    touched.database && errors.database
                                                                        ? "error"
                                                                        : ""
                                                                }
                                                                disabled={(connectedList?.database_name) ? true : false}
                                                                value={values.database}
                                                            />
                                                            <ErrorMessage
                                                                name="database"
                                                                component="div"
                                                                className="text-danger"
                                                            />
                                                        </div>
                                                        {/* <div className="input-wrapper mt-3">
                              <label className="copilot-label-txt">
                                {t("UploadPEMFile")}
                              </label>
                              <input
                                type="file"
                                name="pemFile"
                                accept=".pem,.ppk"
                                className="copilot-model-input w-100"
                                onChange={(event) =>
                                  handleFileChange(event, setFieldValue)
                                }
                                ref={fileInputRef}
                              />
                              <ErrorMessage
                                name="pemFile"
                                component="div"
                                className="text-danger"
                              />
                            </div> */}
                                                        {/* temporary */}
                                                        {/* <div className="input-wrapper">
                                                            <label className="copilot-label-txt">{t('Param')}</label>
                                                            <div className="key-values-wrapper">
                                                                {values?.params?.map((_: any, index: any) => (
                                                                    <div className="d-flex gap-2 mb-2 align-items-center">
                                                                        <div className="">
                                                                            <Field
                                                                                name={`params[${index}].key`}
                                                                                as={Input}
                                                                                className="copilot-model-input"
                                                                                placeholder="key"
                                                                                onChange={handleChange}
                                                                            />
                                                                        </div>
                                                                        <div className="">
                                                                            <Field
                                                                                name={`params[${index}].value`}
                                                                                as={Input}
                                                                                className="copilot-model-input"
                                                                                placeholder="value"
                                                                                onChange={handleChange} />
                                                                        </div>
                                                                        <div className="d-flex gap-2 align-items-center">
                                                                            {index === values?.params?.length - 1 && (
                                                                                <div className="">
                                                                                    <img
                                                                                        src={AddIcon}
                                                                                        alt="add"
                                                                                        className="img-param mt-1"
                                                                                        onClick={() => handleAddParams(setFieldValue, values)}
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                            {values?.params?.length > 1 && (
                                                                                <div className="">
                                                                                    <img
                                                                                        src={RemoveIcon}
                                                                                        alt="remove"
                                                                                        className="img-param mt-1"
                                                                                        onClick={() => handleRemoveParam(index, setFieldValue, values)}
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div> */}
                                                    </div>
                                                    <div className="d-flex justify-content-end input-wrapper-connection">
                                                        <Button
                                                            className="connect-btn"
                                                            htmlType="submit"

                                                        >
                                                            {t("Connect")}
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-7 col-lg-8 d-flex">
                                                <div className="database-list">
                                                    <div className="d-flex justify-content-between flex-wrap pe-3 pb-2 align-items-center">
                                                        <p className="copilot-dbtitle-txt mb-0">
                                                            {t("Databases")}
                                                        </p>
                                                        <div className="d-flex gap-3 justify-content-end align-items-center mb-2">
                                                            <Input
                                                                placeholder="Search Database"
                                                                variant="borderless"
                                                                className="search-copilot"
                                                                onChange={(e) => setSearchValue(e.target.value)}
                                                                prefix={<img src={search} alt="searh" />}
                                                            />
                                                        </div>
                                                    </div>
                                                    <hr className="hrStyle-copilot me-3" />
                                                    {/* temporary command */}
                                                    {/* <div className="d-flex align-items-center flex-wrap justify-content-between gap-3 mt-2 me-3">
                                                        <div className="copilot-segment">
                                                            <Segmented
                                                                value={alignValue}
                                                                onChange={setAlignValue}
                                                                options={["All", "Last Created", "Recently opened"]}
                                                            />
                                                        </div>
                                                    </div> */}
                                                    <div className="w-100 pe-3 ">
                                                        <TopnavBar handlecheck={handlecheck} hanldeConfirmDelete={handleCOnfirmDelete} listToRender={listToRender} isActive={isActive} setIsActive={setIsActive} />

                                                    </div>
                                                    <div className="container w-100 p-0 m-auto">
                                                        <div
                                                            className={`d-flex justify-content-start align-items-center flex-wrap p-1 gap-2 ${listToRender?.length > 0 ? "database-list-wrapper" : "database-list-result"} w-100`}
                                                        >
                                                            {Array.isArray(listToRender) &&
                                                                listToRender.length > 0 ? (
                                                                listToRender?.map((res: any, index: any) => (
                                                                    <div key={index} className="position-relative database-button max-w" onClick={() => handleGetDatabaseDetails(res)} tabIndex={0}>
                                                                        {check && (
                                                                            <input
                                                                                type="checkbox"
                                                                                className="position-absolute model-checkbox"
                                                                                style={{ top: "5px", right: "5px", opacity: check ? "1" : "0" }}
                                                                                tabIndex={0}
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                }}
                                                                                onChange={(e) => {
                                                                                    e.stopPropagation();
                                                                                    onModelChecked(res);
                                                                                }}
                                                                                onKeyDown={(e) => {
                                                                                    if (e.key === "Enter") {
                                                                                        e.preventDefault();
                                                                                        e.stopPropagation();
                                                                                        onModelChecked(res);
                                                                                    }
                                                                                }}
                                                                                checked={selectedModuleIds.includes(res?.
                                                                                    connection_key || res?.connectionId)}
                                                                            />
                                                                        )}


                                                                        {/* <button
                                      className="p-2  db-btn"
                                      onClick={() =>
                                        handleGetDatabaseDetails(res)
                                      }
                                      tabIndex={0}
                                      type="button"
                                    > */}
                                                                        {/* <button className="database-button" key={index} onClick={() => handleGetDatabaseDetails(res)}> */}
                                                                        <div className="text-center">
                                                                            <div className="database-section">
                                                                                <Popover
                                                                                    placement="bottomRight"
                                                                                    className="data-explor"
                                                                                    content={() =>
                                                                                        cardActions(index, res)
                                                                                    }
                                                                                    arrow={false}
                                                                                    trigger="click"
                                                                                    open={openPopoverIndex === index}
                                                                                    onOpenChange={(open) => {
                                                                                        if (open) {
                                                                                            setOpenPopoverIndex(index);
                                                                                        } else {
                                                                                            setOpenPopoverIndex(null);
                                                                                        }
                                                                                    }}
                                                                                >
                                                                                    {/* <img src={MoreIcon} alt="Action Icon" className="more-img" /> */}
                                                                                </Popover>
                                                                                <div className=" ">
                                                                                    <img
                                                                                        src={DataBaseImage}
                                                                                        alt="database"
                                                                                        width={50}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <Typography.Text
                                                                                ellipsis={{
                                                                                    tooltip: res?.connection_name,
                                                                                }}
                                                                                className="text-center copilot-db-name mb-0"
                                                                            >
                                                                                {res?.connection_name
                                                                                }
                                                                            </Typography.Text>
                                                                        </div>
                                                                        {/* </button> */}
                                                                        {/* </button> */}
                                                                    </div>


                                                                ))
                                                            ) : debouncedSearchText?.length > 0 &&
                                                                listToRender.length == 0 ? (
                                                                <div className="text-center copilot-db-name w-100">
                                                                    {t("noresults")}
                                                                </div>
                                                            )
                                                            :
                                                                <div className="text-center copilot-db-name w-100 m-auto">
                                                                    {t("newConnections")}
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                        <DeleteConfirmModel
                            visible={deleteModalOpen}
                            onCancel={() =>
                                setDeleteModalOpen((prev) => ({
                                    ...prev,
                                    state: false,
                                }))
                            }
                            title={t("deleteModalConn.title")}
                            onConfirm={handleDeleteDatabase}
                            cancelText="Cancel"
                            okText="Confirm, delete"
                            content={t("deleteModalConn.description")}
                            count={deleteModalOpen?.Databasename?.length}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConnectionModal;
